import React from "react";
import { useFetch } from "@/lib/useData";

/**
 * WhatsApp click-to-chat floating button.
 * Hidden entirely when site_settings.contact.whatsapp is empty.
 * Renders bottom-left (won't collide with cookie banner / sticky CTA).
 */
export default function WhatsAppButton() {
  const { data: settings } = useFetch("/site-settings");
  const raw = (settings?.contact?.whatsapp || "").trim();
  if (!raw) return null;
  const number = raw.replace(/[^\d+]/g, "");
  const href = `https://wa.me/${number.replace(/^\+/, "")}?text=${encodeURIComponent("Hello Infinity Medical Group, I have a question.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Infinity Medical Group on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed left-4 bottom-20 lg:bottom-6 z-40 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white border border-navy-100 shadow-card hover:shadow-soft text-navy-800 text-sm font-semibold transition-all hover:-translate-y-0.5"
    >
      <span aria-hidden="true" className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-[#25D366] text-white">
        <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4"><path d="M20.5 3.5A11.7 11.7 0 0 0 12 0C5.4 0 0 5.4 0 12c0 2.1.5 4.2 1.6 6L0 24l6.2-1.6c1.7.9 3.7 1.4 5.8 1.4 6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.3zM12 21.6c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.7 1 1-3.6-.2-.4A9.6 9.6 0 0 1 2.4 12C2.4 6.7 6.7 2.4 12 2.4S21.6 6.7 21.6 12 17.3 21.6 12 21.6zm5.3-7.2c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-1 1.1-.2.2-.4.2-.6.1-1.8-.9-3-1.6-4.2-3.6-.3-.5.3-.5.9-1.7.1-.2.1-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5 1.9.8 2.6.9 3.6.7.6-.1 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.1-.3-.2-.5-.3z"/></svg>
      </span>
      <span className="hidden sm:inline">WhatsApp</span>
    </a>
  );
}
